<script setup lang="ts">
import { inject, type Ref } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-fomantic-ui'
import { useRoomStore } from '@/stores/rooms'
import type { Room } from '@/models/Room'
import { ScanTarget } from '@/models/Scan'
import Title from '@/components/Title.vue'
import Scanner from '@/components/Scanner/Scanner.vue'
import RoomScanHeading from '@/components/Heading/RoomScanHeading.vue'

const router = useRouter()
const { toast } = useToast()

const roomStore = useRoomStore()
const room = inject('room') as Ref<Room | null>

const barcodeScanned = async (value: string) => {
  room.value = roomStore.findByCode(value)

  if (!room.value) {
    toast({
      position: 'centered',
      message: `Le code barre scanné n'est pas celui d'un local.`,
      type: 'warning',
    })
  }

  router.push({ name: 'move-container-container' })
}
</script>

<template>
  <div class="page move-container-room">
    <Title>Accueil</Title>
    <RoomScanHeading></RoomScanHeading>
    <Scanner class="scanner" :target="ScanTarget.Room" @barcode-scanned="barcodeScanned"></Scanner>
  </div>
</template>
